import { BaseIcon, BaseIconProps } from '../../../malty/atoms/BaseIcon';
import React from 'react';

export const CheckboxCheckAlternate = ({ dataTestId = 'icon-CheckboxCheckAlternate', ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} dataTestId={dataTestId}>
    <g fillRule="evenodd">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zM6 5h12a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1zm9.333 5.889a1.111 1.111 0 01.13 2.215l-.13.007H8.667a1.111 1.111 0 01-.13-2.215l.13-.007z" />
    </g>
  </BaseIcon>
);
